import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AssetStoragePermissionGroupDTO, FilterDTO, FilterOperator, PagedResultDTOOfUserInfoDTO, Role, UserInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { MultiSelectItem } from 'src/app/base/shared/autocomplete/multi-select-item';
import { UserManagementService } from 'src/app/base/user-management/user-management.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RoleService } from 'src/app/base/services/role.service';
import { CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { GridLocalDataBaseComponent } from 'src/app/base/shared/grid-base/grid-local-data-base.component';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';

import { AutocompleteComponent } from '../../../../base/shared/autocomplete/autocomplete.component';

@Component({
    selector: 'app-permission-group-user-assignment',
    templateUrl: './permission-group-user-assignment.component.html',
    styleUrls: ['./permission-group-user-assignment.component.scss'],
    imports: [AutocompleteComponent, GridModule, QueryBuilderModule, TranslateModule]
})
export class PermissionGroupUserAssignmentComponent extends GridLocalDataBaseComponent {
  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  @Input()
  public permissionGroup: AssetStoragePermissionGroupDTO;

  public fields: Object = { text: 'name', value: 'id' };
  public selectedUserId: string;
  public customEditSettings = {
    allowEditing: false,
    allowAdding: true,
    allowDeleting: true
  };

  @Output()
  public dataChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  private users: UserInfoDTO[];
  private selectedUser: UserInfoDTO;

  constructor(
    private userService: UserManagementService,
    translateService: TranslateService,
    private roleService: RoleService
  ) {
    super(null, translateService, null);
    this.gridCommands = [{
      type: 'Delete',
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-trash-can e-icons e-danger'
      }
    } as CommandModel];
  }

  public addUserToGrid() {
    // add the selected user to the grid

    const newRecord = {
      userId: this.selectedUserId,
      user: this.selectedUser,
    };
    (this.grid as any).addRecord(newRecord, 0);
    this.selectedUserId = null;
    this.dataChange.emit(this.grid.dataSource as any[]);
  }

  public onValueChange(userId: string) {
    this.selectedUserId = userId;
    // find the user and set it to selectedUser
    this.selectedUser = this.users.find((user: UserInfoDTO) => user.userId === userId);
  }

  public searchUsers(searchText: string): Observable<MultiSelectItem[]> {
    const filters = [
      // list only users that have role AssetStorageGroupMember
      new FilterDTO({ isComplex: false, field: 'Roles', operator: FilterOperator.Equal, value: Role.AssetStorageGroupMember.toString()})
    ];
    return this.userService.searchUsers(searchText, 20, filters).pipe(map((usersPaged: PagedResultDTOOfUserInfoDTO) => {
      this.users = usersPaged.items;
      //filter out the users that are already in the grid
      const alreadyInGrid = this.grid.dataSource as any[];
      var filteredUsers = usersPaged.items.filter((user: UserInfoDTO) => {
        return !alreadyInGrid.some((gridUser: any) => gridUser.userId === user.userId);
      });
      // get only the user with webaceess role
      const webUserRoles = this.roleService.roleMappingInfo.viewRoles;
      filteredUsers = filteredUsers.filter((user: UserInfoDTO) => {
        return user.roles.some((role: any) => webUserRoles.some((webUserRole: any) => webUserRole === role));
      });

      // filter out the domain users
      filteredUsers = filteredUsers.filter((user: UserInfoDTO) => {
        return !user.userName.includes('\\');
      });
      return filteredUsers.map((userInfo: UserInfoDTO) => {
        return { id: userInfo.userId, name: this.getUserDisplayName(userInfo) };
      });
    }));
  }

  public override commandClicked(args: any): void {
    if (args.commandColumn.buttonOption.iconCss.includes('icon-trash-can')) {
      this.modalHelperService.confirm(
        'i18n.core.modal.delete.title',
        'i18n.core.modal.delete.content',
        () => {
          // remove the user from permeission group
          const userId = args.rowData.userId;
          this.permissionGroup.users = this.permissionGroup.users.filter((user: any) => user.userId !== userId);
          // delete user from grid
          this.grid.deleteRecord('userId', args.rowData);
          // refresh the grid
          this.grid.refresh();
          this.dataChange.emit(this.grid.dataSource as any[]);
        }
      );
      args.cancel = true;
    }
  }

  private getUserDisplayName(userInfo: UserInfoDTO): any {
    return userInfo.firstname + ' ' + userInfo.lastname + ' (' + userInfo.userName + ')';
  }
}
